module.exports = __webpack_public_path__ + "static/media/profile.566d5b31.jpg";